import { combineReducers } from 'redux';
import cardReducer from './cardReducer';
import personalInfoReducer from './personalInfoReducer';
import authUserReducer from './authUserReducer';
import occupationReducer from './occupationReducer';
import incomeExpensesReducer from './incomeExpensesReducer';
import verificationReducer from './verificationReducer';
import applicationReducer from './applicationReducer';
import offerCodeReducer from './offerCodeReducer';
import Storage from '../utils/Storage';

const appReducer = combineReducers({
  card: cardReducer,
  personalInfo: personalInfoReducer,
  authUsers: authUserReducer,
  occupation: occupationReducer,
  incomeExpenses: incomeExpensesReducer,
  verification: verificationReducer,
  application: applicationReducer,
  offerCode: offerCodeReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STATE') {
    Storage().removeItem();
    state = undefined;
  }

  return appReducer(state, action)
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js